import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
import _imports_0 from './assets/image/jfcj/close.png';
const _hoisted_1 = {
  key: 0,
  class: "app-container"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "btn"
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "step1"
};
const _hoisted_9 = {
  class: "step2"
};
const _hoisted_10 = {
  class: "step3"
};
const _hoisted_11 = {
  class: "tips"
};
const _hoisted_12 = {
  class: "qcText1"
};
const _hoisted_13 = {
  class: "qcText2"
};
const _hoisted_14 = {
  class: "btn"
};
const _hoisted_15 = {
  key: 2
};
const _hoisted_16 = {
  class: "title"
};
const _hoisted_17 = {
  class: "step1"
};
const _hoisted_18 = {
  class: "url"
};
const _hoisted_19 = {
  class: "step2"
};
const _hoisted_20 = {
  class: "step3"
};
const _hoisted_21 = {
  class: "tips"
};
const _hoisted_22 = {
  class: "qcText1"
};
const _hoisted_23 = {
  class: "btn"
};
const _hoisted_24 = {
  key: 3,
  class: "tips-title"
};
const _hoisted_25 = {
  key: 0,
  class: "tips-container"
};
const _hoisted_26 = {
  class: "tips-title"
};
const _hoisted_27 = {
  class: "tips-content"
};
const _hoisted_28 = {
  class: "tips-content"
};
const _hoisted_29 = {
  class: "tips-btn"
};
const _hoisted_30 = {
  class: "close"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = {
  class: "banner-news"
};
const _hoisted_33 = {
  class: "title"
};
const _hoisted_34 = {
  class: "detail-content"
};
const _hoisted_35 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HeaderContainer = _resolveComponent("HeaderContainer");
  const _component_LoginPage = _resolveComponent("LoginPage");
  const _component_van_checkbox = _resolveComponent("van-checkbox");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock(_Fragment, null, [$setup.initSdhType ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$setup.isPay ? (_openBlock(), _createBlock(_component_HeaderContainer, {
    key: 0,
    onShowLogin: $setup.showLogins,
    token: $setup.token,
    class: "header-fix"
  }, null, 8, ["onShowLogin", "token"])) : _createCommentVNode("", true), $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_LoginPage, {
    onCloseLoginContainer: $setup.closeLoginContainer,
    ref: "loginPage"
  }, null, 8, ["onCloseLoginContainer"])])) : _createCommentVNode("", true), _createVNode(_component_van_popup, {
    show: $setup.desktopPopup,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $setup.desktopPopup = $event),
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [!$setup.isMobileType ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "show-m-list-bgc-sec-pc",
      onClick: _cache[0] || (_cache[0] = $event => $setup.closePopup())
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("qc_sdk_save_page")), 1), _createElementVNode("div", {
      class: "step1",
      innerHTML: _ctx.$t('qc_sdk_navigation_bar')
    }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("qc_sdk_sure_text")), 1)])) : _createCommentVNode("", true), $setup.isMobileType ? (_openBlock(), _createElementBlock("div", _hoisted_6, [!$setup.isWechat && !$setup.isAndroid ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "show-m-list-bgc-sec",
      onClick: _cache[1] || (_cache[1] = $event => $setup.closePopup())
    }, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("qc_sdk_add_desktop")), 1), _createElementVNode("div", _hoisted_8, "1." + _toDisplayString(_ctx.$t("qc_sdk_browser_click")), 1), _createElementVNode("div", _hoisted_9, "2." + _toDisplayString(_ctx.$t("qc_sdk_add_home_screen")), 1), _createElementVNode("div", _hoisted_10, "3." + _toDisplayString(_ctx.$t("qc_sdk_add_success")), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("qc_sdk_add_home_screen")), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("qc_sdk_official_recharge")), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("qc_sdk_official_recharge")), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("qc_sdk_sure_text")), 1)])) : _createCommentVNode("", true), $setup.isWechat ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "show-m-list-bgc-wechat",
      onClick: _cache[2] || (_cache[2] = $event => $setup.closePopup())
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.isMobileType ? (_openBlock(), _createElementBlock("div", _hoisted_15, [!$setup.isWechat && $setup.isAndroid ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "show-m-list-bgc-sec-android",
      onClick: _cache[3] || (_cache[3] = $event => $setup.closePopup())
    }, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("qc_sdk_add_desktop")), 1), _createElementVNode("div", _hoisted_17, "1." + _toDisplayString(_ctx.$t("qc_sdk_browser_click_android")), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("qc_sdk_browser_url")), 1), _createElementVNode("div", _hoisted_19, "2." + _toDisplayString(_ctx.$t("qc_sdk_add_home_screen")), 1), _createElementVNode("div", _hoisted_20, "3." + _toDisplayString(_ctx.$t("qc_sdk_add_success")), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("qc_sdk_add_home_screen")), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("qc_sdk_browser_install")), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("qc_sdk_sure_text")), 1)])) : _createCommentVNode("", true), $setup.isWechat ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "show-m-list-bgc-wechat",
      onClick: _cache[4] || (_cache[4] = $event => $setup.closePopup())
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.showChecked ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_van_checkbox, {
      modelValue: $setup.checked,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.checked = $event),
      "checked-color": "#8383FF"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("qc_sdk_no_reminder_again")), 1)]),
      _: 1
    }, 8, ["modelValue"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showLoginout,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => $setup.showLoginout = $event),
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [$setup.showLoginout ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("qc_sdk_change_account")), 1), _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("qc_sdk_need_change_account")), 1), _createElementVNode("div", _hoisted_28, "（" + _toDisplayString(_ctx.$t("qc_sdk_logout_popup")) + "）", 1), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
      class: "cancel-btn",
      onClick: _cache[7] || (_cache[7] = $event => $setup.showLoginout = false)
    }, _toDisplayString(_ctx.$t("qc_sdk_cancel_text")), 1), _createElementVNode("div", {
      class: "confirm-btn",
      onClick: _cache[8] || (_cache[8] = $event => $setup.logoutBtn())
    }, _toDisplayString(_ctx.$t("qc_sdk_sure_text")), 1)])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showService,
    "onUpdate:show": _cache[11] || (_cache[11] = $event => $setup.showService = $event),
    position: "bottom",
    style: {
      height: '85%'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createElementVNode("img", {
      src: _imports_0,
      onClick: _cache[10] || (_cache[10] = $event => $setup.showService = false)
    })]), _createElementVNode("iframe", {
      ref: "myIframe",
      class: "iframe-service",
      src: $setup.kfUrl,
      frameborder: "0"
    }, null, 8, _hoisted_31)]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.announcementPopup,
    "onUpdate:show": _cache[13] || (_cache[13] = $event => $setup.announcementPopup = $event),
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("qc_sdk_tips")), 1), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", {
      class: "detail",
      innerHTML: $setup.announcementText
    }, null, 8, _hoisted_35)]), _createElementVNode("div", {
      class: "confirm",
      onClick: _cache[12] || (_cache[12] = $event => $setup.closeAnnouncement())
    }, _toDisplayString(_ctx.$t("qc_sdk_sure_text")), 1)])]),
    _: 1
  }, 8, ["show"])])) : _createCommentVNode("", true), $setup.initSdhType ? (_openBlock(), _createBlock(_component_router_view, {
    key: 1
  })) : _createCommentVNode("", true)], 64);
}